import { TenantHeading, HeaderContainer } from "./style";
import Skeleton from "react-loading-skeleton";
import React from "react";
import { useQueryClient } from "react-query";
import { TenantLogoInfo } from "@customTypes/tenant/imageLoader";
import { useHistory } from "react-router-dom";
import BriefcaseIcon from "@components/svgs/BriefcaseIcon";

type TenantLogoLoaderProps = {
  height?: number;
  width?: number;
  clickable?: boolean;
  noShadow?: boolean;
  isHome?: boolean;
};

const TenantLogoLoader: React.FC<TenantLogoLoaderProps> = ({
  height,
  width,
  clickable = false,
  noShadow = false,
  isHome = false,
}) => {
  const queryClient = useQueryClient();
  const history = useHistory();

  const tenantInfo = queryClient.getQueryData<TenantLogoInfo>("getTenantLogoInfo");
  const image = queryClient.getQueryData<string>(["getTenantImage", tenantInfo?.logoURL]);

  const handleClick = () => {
    if (clickable) history.push("/home");
  };

  if (!tenantInfo?.tenantName) return <div style={{ height: 100 }}></div>;

  if (!tenantInfo?.logoURL)
    return (
      <HeaderContainer
        onClick={handleClick}
        clickable={clickable}
        noShadow={noShadow}
        asNav={isHome}
      >
        <BriefcaseIcon />
        <TenantHeading size="md" margin="md" noMargin>
          {tenantInfo.tenantName}
        </TenantHeading>
      </HeaderContainer>
    );

  return (
    <HeaderContainer noShadow onClick={handleClick} clickable={clickable}>
      {!image ? <Skeleton width={width ?? 160} height={height ?? 72} /> : <img src={image} />}
    </HeaderContainer>
  );
};

export default TenantLogoLoader;
